import React from 'react';
import useDataStore from '../../store/dataStore';
import MedibuddyLogo from '../../assets/homepage/mb_logo.svg';
import '../../assets/css/pfc.css';

const Logo = () => (
  <img src={MedibuddyLogo} alt="MediBuddy" style={{ height: 36, width: 'auto' }} />
);

const normalizeSource = source => (typeof source === 'string' ? source.trim().toLowerCase() : '');
const isPoonawallaSource = source => normalizeSource(source) === 'poonawalla' || normalizeSource(source) === 'test poonawala';

const PFCHeader = () => {
  const data = useDataStore((state) => state.data);
  const source = typeof window !== 'undefined' ? localStorage.getItem('source') : '';
  const isPoonawalla = isPoonawallaSource(source);

  const partnerName = isPoonawalla ? (data && data.partnerName) || 'Poonawalla Fincorp' : '';
  const partnerSub = isPoonawalla ? (data && data.partnerSubName) || 'Affinity Partner Portal' : '';
  const partnerLogo = isPoonawalla && data && data.logo;
  const contactPhone = '9513881515';

  return (
    <nav className="pfc-header">
      <div className="pfc-header-left">
        <div className="pfc-logo"><Logo /></div>
        {partnerName && (
          <>
            <div className="pfc-header-divider" />
            <div>
              <div className="pfc-partner-name">{partnerName}</div>
              <div className="pfc-partner-sub">{partnerSub}</div>
            </div>
          </>
        )}
        {partnerLogo && <div className="pfc-header-divider" />}
        {partnerLogo && (
          <img
            src={partnerLogo}
            alt="Partner Logo"
            style={{ maxWidth: '120px', maxHeight: '40px', objectFit: 'contain' }}
          />
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div className="pfc-phone-pill">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M7.5 1.5C4.2 1.5 1.5 4.2 1.5 7.5S4.2 13.5 7.5 13.5 13.5 10.8 13.5 7.5 13.5 10.8 1.5 7.5 1.5z" stroke="#47566A" strokeWidth="1.2" />
            <path d="M7.5 5v2.5L9.5 9.5" stroke="#47566A" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
          {contactPhone}
        </div>
      </div>
    </nav>
  );
};

export default PFCHeader;
